import { JobApplicationAssessments } from '@bluecrew/crew-member-backend-angular-client';

export const i9AssessmentId = 'i9';
export const reI9AssessmentId = 'reI9';
export const inactiveI9AssessmentId = 'inactiveI9';

export const isAnyI9Assessment = (item: JobApplicationAssessments) => {
  return [i9AssessmentId, reI9AssessmentId, inactiveI9AssessmentId].includes(item?.assessment.id);
}

export const isReI9AssessmentPresent = (assessments: JobApplicationAssessments[]) => {
  return assessments.some((a) => a.assessment.id === reI9AssessmentId);
};

export const isInactiveI9AssessmentPresent = (assessments: JobApplicationAssessments[]) => {
  return assessments.some(a => a.assessment.id === inactiveI9AssessmentId);
};

